<div class="bloc">
  <div class="bloc-header">
    <div class="bloc-title">Configuration eForm</div>
  </div>
  <div class="env-selector">
    <label class="checkbox-item">
      <input type="checkbox" [(ngModel)]="form.isProduction" (ngModelChange)="onFieldChange()"/>
      <span class="checkmark"></span>
      <span>Production</span>
    </label>
    <span class="env-badge" [class.prod]="form.isProduction" [class.acc]="!form.isProduction">
      {{ form.isProduction ? 'PRD' : 'ACC' }}
    </span>
  </div>
  <div class="form-grid">
    <div class="form-field">
      <label class="form-label">Host</label>
      <input type="text" class="form-input" placeholder="Host" [(ngModel)]="form.host"
             (ngModelChange)="onFieldChange()"/>
    </div>
    <div class="form-field">
      <label class="form-label">Grant Type</label>
      <input type="text" class="form-input" placeholder="Grant Type" [(ngModel)]="form.grantType"
             (ngModelChange)="onFieldChange()"/>
    </div>
    <div class="form-field">
      <label class="form-label">Integration Version</label>
      <input type="text" class="form-input" placeholder="Integration Version" [(ngModel)]="form.integrationVersion"
             (ngModelChange)="onFieldChange()"/>
    </div>
    <div class="form-field">
      <label class="form-label">Nom d'utilisateur</label>
      <input type="text" class="form-input" placeholder="Nom d'utilisateur" [(ngModel)]="form.userName"
             (ngModelChange)="onFieldChange()"/>
    </div>
    <div class="form-field">
      <label class="form-label">Mot de passe <span class="required">*</span></label>
      <input type="password" class="form-input" placeholder="Mot de passe" required [(ngModel)]="form.password"
             (ngModelChange)="onFieldChange()"/>
    </div>
  </div>
</div>
